import(/* webpackChunkName: "focusbox" */ '../../Focusbox/Styles/focusbox.scss');

await import(/* webpackChunkName: "jquery-match-height" */ "jquery-match-height");

window.am = window.am || {};

window.am.focusbox = new function () {
    var that = this;

    that.init = function () {
        $('.focusbox-element-container.js-equalHeight').matchHeight();
    };
};

window.am.focusbox.init();